<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      <span *ngIf="!ProductId">Add Product</span>
      <span *ngIf="ProductId">
        <strong class="text-danger">Update {{Status}}</strong>
        <small title="View Detail" class="title-link-left" (click)="fn_viewProductdetais(ProductId)">
          <span class="material-icons">visibility</span>
          View Only
        </small>
      </span>


      <small class="pull-right title-link">
        <a [routerLink]="['/store/productlisting']">Warehouse Products</a>
      </small>
      <span class="clearfix"></span>
    </h5>
    <p class="add-product-dashboard">
      Fill in the required details about your product. When you’re done, click “Submit”, and we’ll review it.
      Once we’ve approved it, you can create a new shipment and mail your product to us.
    </p>
    <form [formGroup]="addCustomProductForm" (submit)="AddCustomProduct(addCustomProductForm)" autocomplete="off">
      <div class="store-set-blk vw-pro-ux">
        <div class="store-set-ui">
          <div class="row">
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title>
                  Product Information
                </mat-card-title>
                <mat-card-content>
                  <div class="example-form">
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                           <mat-label>Product Title</mat-label>
                          <input matInput placeholder="Product Title" formControlName="Title">
                          <mat-error *ngIf="f.Title.touched && f.Title.invalid && f.Title.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Title.valid && (!f.Title.hasError('pattern') && f.Title.touched && f.Title.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.Title.valid && (f.Title.hasError('pattern') && f.Title.dirty)">
                            Title contains invalid characters
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                           <mat-label>Description</mat-label>
                          <textarea matInput placeholder="Description" formControlName="Description" rows="4"></textarea>
                          <mat-error *ngIf="f.Description.touched && f.Description.invalid && f.Description.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Description.valid && (!f.Description.hasError('pattern') && f.Description.touched && f.Description.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                           <mat-label>SKU (optional)</mat-label>
                          <input matInput placeholder="SKU (optional)" formControlName="SKU">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">

                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                          <mat-label>Retail Price (USD $)</mat-label>
                          <input matInput placeholder="Retail Price (USD $)" required formControlName="RetailPrice">
                          <mat-error *ngIf="f.RetailPrice.touched && f.RetailPrice.invalid && f.RetailPrice.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.RetailPrice.valid && (!f.RetailPrice.hasError('pattern') && f.RetailPrice.touched && f.RetailPrice.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.RetailPrice.valid && (f.RetailPrice.hasError('pattern') && f.RetailPrice.dirty)">
                            Price Should contain only numbers and decimal
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-6 add-wh-product-mb">
                        <ng-multiselect-dropdown #multiSelect [placeholder]="'Select Category'" [data]="dropdownList"
                          formControlName="ProductCategories" [settings]="settings" [disabled]="false"
                          (onSelect)="onItemSelect($event)" (onDeSelect)="onDeSelect($event)"
                          class="multiselect-dropdown-custom">
                        </ng-multiselect-dropdown>
                      </div>
                      <div class="col-md-6 add-wh-product-mb">
                        <ng-multiselect-dropdown #multiSelect [placeholder]="'Select Sub Category'"
                          [data]="dropdownListSubCategory" formControlName="Productsubcategories" [settings]="subCateSettings"
                          [disabled]="false" (onDeSelect)="onDeSelect($event)" class="multiselect-dropdown-custom">
                        </ng-multiselect-dropdown>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title>
                  Dimension
                </mat-card-title>
                <mat-card-content>
                  <div class="example-form">
                    <div class="row text-muted">
                      <div class="col-sm-12">
                        <strong>Dimension</strong>
                        <br />
                        <small>
                          Please enter the
                          dimensions of the product when it is folded or packaged for mailing.
                        </small>
                      </div>
                    </div>
                    <div class="row text-muted">
                      <div class="col-sm-6">
                        <mat-select formControlName="UnitId" (selectionChange)="UpdatePlaceholders($event.value)">
                          <mat-option *ngFor="let unit of Units" [value]="unit.UnitId">
                            {{unit.UnitText}}
                          </mat-option>
                        </mat-select>
                      </div>
                      <div class="col-sm-6">
                        <br />
                        <mat-checkbox formControlName="IsPackaged"><strong>Product is packaged</strong></mat-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Width ({{lenghtPlaceholder}})</mat-label>
                          <input matInput placeholder="Width ({{lenghtPlaceholder}})" type="number" required
                            formControlName="Width">
                          <mat-error *ngIf="f.Width.touched && f.Width.invalid && f.Width.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Width.valid && (!f.Width.hasError('pattern') && f.Width.touched && f.Width.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.Width.valid && (f.Width.hasError('pattern') && f.Width.dirty)">
                            Width Should contain only numbers and decimal
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Length ({{lenghtPlaceholder}})</mat-label>
                          <input matInput placeholder="Length ({{lenghtPlaceholder}})" type="number" maxlength="5"
                            required formControlName="Length">
                          <mat-error *ngIf="f.Length.touched && f.Length.invalid && f.Length.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Length.valid && (!f.Length.hasError('pattern') && f.Length.touched && f.Length.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.Length.valid && (f.Length.hasError('pattern') && f.Length.dirty)">
                            Length Should contain only numbers and decimal
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Height ({{lenghtPlaceholder}})</mat-label>
                          <input matInput placeholder="Height ({{lenghtPlaceholder}})" type="number" maxlength="5"
                            required formControlName="Height">
                          <mat-error *ngIf="f.Height.touched && f.Height.invalid && f.Height.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Height.valid && (!f.Height.hasError('pattern') && f.Height.touched && f.Height.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.Height.valid && (f.Height.hasError('pattern') && f.Height.dirty)">
                            Height Should contain only numbers and decimal
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Weight ({{lenghtPlaceholder}})</mat-label>
                          <input matInput placeholder="Weight ({{weightPlaceholder}})" type="number" maxlength="5"
                            required formControlName="Weight">
                          <mat-error *ngIf="f.Weight.touched && f.Weight.invalid && f.Weight.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Weight.valid && (!f.Weight.hasError('pattern') && f.Weight.touched && f.Weight.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.Weight.valid && (f.Weight.hasError('pattern') && f.Weight.dirty)">
                            Weight Should contain only numbers and decimal
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mat-crd-ui">
              <mat-card class="add-wh-product">
                <mat-card-title>
                  Variants
                </mat-card-title>
                  <mat-card-content>
                    <!--<div>
                      <span style="font-weight: bold; font-size: large;">Variants</span>
                      <span class="hyperlink" (click)="fn_AddVariant()" style="color:cornflowerblue; float: right;">
                        Add
                        Variant
                      </span>
                    </div>-->
                    <div>
                      <small class="text-muted">
                        Add variants if the product comes in several versions, like different sizes or colors.
                        <br />
                        i.e Colors can be Red, Green, Multi Color, Transparent etc
                        <br />
                        Size can be OS, S, M, L etc
                      </small>
                    </div>
                    <br />
                    <div>
                      <div formArrayName="rows">
                        <div class="row" *ngFor="let row of addCustomProductForm.get('rows')['controls']; let i = index"
                          [formGroupName]="i">
                          <div class="col-sm-3">
                            <mat-form-field class="example-full-width">
                              <mat-label>Option Name</mat-label>
                              <input matInput readonly formControlName="optionName">
                            </mat-form-field>
                          </div>
                          <div class="col-sm-9" *ngIf="i==0">
                            <ng-multiselect-dropdown #multiSelect [placeholder]="'Select Colors'"
                            [(ngModel)]="varientValues[i]"
                            [data]="colorDropdownList" formControlName="optionValue" [settings]="colorSettings"
                            [disabled]="false" (onSelect)="addColor($event, 0)" (onDeSelect)="removeColor($event, 0)"
                            class="multiselect-dropdown-custom">
                          </ng-multiselect-dropdown>
                          </div>
                          <div class="col-sm-9" *ngIf="i==1">
                            <mat-form-field floatLabel="never" class="example-full-width">
                              <mat-chip-list #varientValueList aria-label="Size selection">
                                <mat-chip *ngFor="let value of varientValues[i]" [selectable]="true" [removable]="true"
                                  (removed)="removeChip(value, i)">
                                  {{value}}
                                  <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
                                </mat-chip>
                                <mat-label>{{ i == 0 ? 'New color...' : 'New size...' }}</mat-label>
                                <input matInput #input placeholder="{{ i == 0 ? 'New color...' : 'New size...' }}"
                                  formControlName="optionValue" (input)="input.value=$event.target.value.toUpperCase()"
                                  [matChipInputFor]="varientValueList"
                                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                                  (matChipInputTokenEnd)="addChip($event, i)">
                              </mat-chip-list>
                            </mat-form-field>
                          </div>
                        </div>

                        <!--<span class="hyperlink text-success" (click)="initGroup()" *ngIf="addCustomProductForm.controls.rows.controls.length >= 1 &&  addCustomProductForm.controls.rows.controls.length < 4 ">
                          <i class="fa fa-plus" aria-hidden="true"></i> Add another option
                        </span>-->
                      </div>
                    </div>
                  </mat-card-content>
              </mat-card>

              <mat-card class="add-wh-product" *ngIf="ImageHashCombination.length > 0">
                <mat-card-title>
                  Upload Product Image
                </mat-card-title>
                <mat-dialog-content class="table-wh-view">
                  <div class="table-responsive pro-tble-outer table-inventory-custom">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th width="25%">Color</th>
                          <th width="25%">Hex Code</th>
                          <th width="50%">Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let row of ImageHashCombination; let colorIndex = index">
                          <tr>
                            <td width="25%">
                              <strong>{{row.Color}}</strong>
                            </td>
                            <td width="25%">
                              <input type="text" class="choose-wh-product-color" [(ngModel)]="row.HexCode"
                                [ngModelOptions]="{standalone: true}" [style.background]="row.HexCode"
                                [(colorPicker)]="row.HexCode">
                              <i title="Choose Color Hex Code" class="fa fa-pencil" aria-hidden="true"
                                [(colorPicker)]="row.HexCode" style="font-size: 25px;"></i>
                            </td>
                            <td width="50%">
                              <span *ngFor="let size of row.Sizes; let j = index">{{size.Size}}&nbsp;&nbsp;&nbsp;
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3" style="border:none;">
                              <div [style.display]="row.cropperReady ? null : 'none'">
                                <button class="margin-5px" type="button" mat-raised-button
                                  (click)="fn_AddImage(colorIndex)">Crop</button>
                                <button class="margin-5px" type="button" mat-raised-button
                                  (click)="fn_CancelCrop(colorIndex)">Cancel</button>
                                <image-cropper [imageChangedEvent]="row.imageChangedEvent" [maintainAspectRatio]="true"
                                  [aspectRatio]="1/ 1" [resizeToWidth]="500" format="jpeg"
                                  (imageCropped)="imageCropped($event, colorIndex)"
                                  (imageLoaded)="imageLoaded(colorIndex)" (loadImageFailed)="loadImageFailed()">
                                </image-cropper>
                              </div>
                              <mat-card-content>
                                <input #inputImage class="inputImage" type="file"
                                  (change)="fn_OnFileChange($event, true,colorIndex)" accept=".jpg,.png,.jpeg">

                                <mat-hint align="start">*Image size should be less than 10 MB</mat-hint>
                              </mat-card-content>
                              <div>
                                <div class="img-upload-container" *ngFor='let img of row.images; let imgIndex = index;'
                                  [ngClass]="{'disableDiv': img.IsDefault}">
                                  <img [src]="img.Image" class="img-upload-thumbnail">


                                  <a class="delete-icon icon-style"
                                    (click)="fn_DeleteImage(colorIndex, imgIndex, img.Id)" matTooltip="Delete">
                                    <i class="material-icons">
                                      delete_forever
                                    </i>
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </mat-dialog-content>
              </mat-card>
            </div>
          </div>
          <div class="text-right sv-up-dt">
            <button class="mat-btn" mat-raised-button cdkFocusInitial [disabled]="addCustomProductForm.invalid">
              Submit
            </button>
          </div>
          <br />
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
